import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { CompanypagesService } from "src/app/_services/companypages.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-salarylist',
  templateUrl: './salarylist.component.html',
  styleUrls: ['./salarylist.component.scss']
})
export class SalarylistComponent implements OnInit {

  start = 0;
  end = 10; //initial value should be equal to pagination index
  totalCount;
  location = "";
  currency = "USD";
  jobtitle = "";
  currencyList = [];
  locationsList = [];
  jobTitleList = [];
  filteredJobTitleList = [];
  paginationOffset = 10; 
  countryList = [];
  cityList = [];
  finalData = [];
  totalSalaryData;
  userCoordinates = {};
  isLoggedinState = true;
  initalLocation;
  activePage = 0;
  prevPage = 1;
  timeout;
  filterApplied:boolean = false;

  @Input() companyId: string;
  @Input() companyName: string;
  @Input() loginModal: TemplateRef<any>;

  constructor(private _companypagesservice: CompanypagesService, private modalService: NgbModal) { }

  ngOnInit(): void {
    //detecting user locations
    window.navigator.geolocation.getCurrentPosition((position) => {
      this.userCoordinates['latitude'] = position.coords.latitude;
      this.userCoordinates['longitude'] = position.coords.longitude;
      this._companypagesservice.getUserLocation(this.userCoordinates).subscribe((data:any) => {
        if(data.status == 'success'){
          if(data.location.split(',')[2]){
            if(data.location.split(',')[2].trim().split(' ')[0].toLowerCase() != 'undefined'){
              this.location = data.location.split(',')[2].trim().toLowerCase();
            } else{
              this.location = data.location.split(',')[2].trim().split(' ')[0].toLowerCase();
            }
          } else if(data.location.split(',')[1]){
            if(data.location.split(',')[1].trim().split(' ')[0].toLowerCase() != 'undefined'){
              this.location = data.location.split(',')[1].trim().toLowerCase();
            } else{
              this.location = data.location.split(',')[1].trim().split(' ')[0].toLowerCase();
            }
          } else if(data.location.split(',')[0]){
            if(data.location.split(',')[0].trim().split(' ')[0].toLowerCase() != 'undefined'){
              this.location = data.location.split(',')[0].trim().toLowerCase();
            } else{
              this.location = data.location.split(',')[0].trim().split(' ')[0].toLowerCase();
            }
          } else{
            this.location = data.location.toLowerCase();
          }
          this.initalLocation = this.location;
          this.getExpAndSal(this.start, this.end);
        } else{
          this.getExpAndSal(this.start, this.end);
        }
      })
    }, (error) => {
      this.initalLocation = '';
      this.getExpAndSal(this.start, this.end);
    }
    );
    
  }

  getExpAndSal(start, end) {
    this._companypagesservice
      .getCompanyExpAndSal(
        this.companyId,
        start,
        end,
        this.location,
        this.currency,
        this.jobtitle,
        !this.isLoggedinState,
        this.paginationOffset
      )
      .subscribe((data: any) => {
        data.finalData?.forEach((item) => {
          item.finalSalary = this.numberWithCommas(item.finalSalary);
          item.finalMaxSalary = this.numberWithCommas(item.finalMaxSalary);
          item.finalMinSalary = this.numberWithCommas(item.finalMinSalary);
        });
        data.finalData?.forEach((item) => {
          if(item.experience){
            item.experience = Math.ceil(parseInt(item.experience));
          }
        })
        this.finalData = data.finalData;
        this.totalCount = data.totalCount;
        this.locationsList = data.allCountries;
        this.jobTitleList = data.allJobTitles;
        this.filteredJobTitleList = data.allJobTitles.slice(0,10)
        this.totalSalaryData = data.totalSalaryData;
        if(this.end>this.totalCount){
          this.end = this.totalCount
        }
        this.currencyList.length = 0;
        data.allCurrency.forEach(item => this.currencyList.push(item.currency))
        if(!(this.locationsList.includes(this.initalLocation))){
          this.initalLocation = '';
        }
        if(data.setAllCountries){
          this.location = '';
          this.initalLocation = '';
        }
      });
  }

  pagination(type, load=0) {
    let callApi = true;
    switch (type) {
      case "next":
        this.start += this.paginationOffset;
        this.end += this.paginationOffset;
        if (this.end > this.totalCount){
          this.end = this.totalCount;
          callApi = false;
        } 
        if (this.start > this.end) this.start -= this.paginationOffset;
        break;

      case "prev":
        this.end = this.start;
        this.start -= this.paginationOffset;
        if (this.start < 0) {
          this.start = 0;
          this.end = this.paginationOffset;
          callApi = false;
        }
        break;

      case "page":
        if(load != this.prevPage){
          this.prevPage = load;
          let pageNum;
          pageNum = this.activePage - 1;
          this.start = pageNum*this.paginationOffset;
          this.end = this.start + this.paginationOffset;
        } else {
          callApi = false;
        }
        break;
    }
    if(callApi){
      this.getExpAndSal(this.start, this.end);
    }
  }

  numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  applyFilter(type, event) {
    if (type == "currency") {
      this.currency = event;
      this.filterApplied = true;
    } else if (type == "location") {
      this.location = event;
      this.filterApplied = true;
    } else if (type == "jobtitle"){
      this.jobtitle = event;
      this.filterApplied = true;
    } else if(type == "clearall"){
      if(this.filterApplied){
        this.location = this.initalLocation;
        this.jobtitle = '';
        this.getTypeaheads();
        this.getExpAndSal(this.start, this.end);
        this.filterApplied = false;
      }
    }
    this.start = 0;
    this.end = this.paginationOffset;
    if(this.filterApplied){
      this.getExpAndSal(this.start, this.end);
    }
  }

  onKeyPress(){
    this.filterApplied = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getTypeaheads();
    },500);
  }

  getTypeaheads(){
    this.jobtitle = this.jobtitle.toLowerCase();
    this.filteredJobTitleList = this.jobTitleList.filter(item => item.includes(this.jobtitle));
  }

  openModal(content){
    this.modalService.open(content, { centered: true });
  }
}
